export const Xlarge = '@media (min-width: 64rem)' // 1024px
export const large = '@media (min-width: 55rem)' // 880px
export const medium = '@media (min-width: 43rem)' // 688px
export const hover = '@media (hover: hover)'; // Supports Hover
export const blur = '@supports (backdrop-filter: blur())' // Supports Backdropfilter Blur